import { z } from 'zod';
// =============================================================================
// Xero Integration
// =============================================================================
export const XeroAuthorizeQuerySchema = z.object({
    returnTo: z.url().optional(),
});
/** Response for both the initial authorize and reconnect routes */
export const XeroAuthorizeResponseSchema = z.object({
    authorizationUrl: z.url(),
});
export const XeroCallbackBodySchema = z.object({
    code: z.string().min(1),
    state: z.string().min(1),
});
export const XeroCallbackResponseSchema = z.object({
    tenants: z.array(z.object({
        tenantId: z.string(),
        tenantName: z.string(),
        tenantType: z.string(),
    })),
});
export const XeroSelectTenantBodySchema = z.object({
    tenantId: z.string().uuid(),
    tenantName: z.string().min(1).max(255),
});
export const XeroConnectionResponseSchema = z.object({
    id: z.string(),
    status: z.enum(['active', 'disconnected', 'needs_reauth', 'pending_tenant_selection']),
    tenantId: z.string().nullable(),
    tenantName: z.string().nullable(),
    defaultAccountCode: z.string().nullable(),
    connectedAt: z.iso.datetime(),
});
export const XeroAccountSchema = z.object({
    code: z.string(),
    name: z.string(),
    type: z.string().nullable(),
    taxType: z.string().nullable(),
});
export const XeroAccountsResponseSchema = z.object({
    accounts: z.array(XeroAccountSchema),
});
export const XeroConnectionSettingsBodySchema = z.object({
    defaultAccountCode: z.string().nullable(),
});
export const XeroExportInvoiceBodySchema = z.object({
    accountCode: z.string().optional(),
});
export const XeroExportInvoiceResponseSchema = z.object({
    xeroInvoiceId: z.string(),
    xeroInvoiceUrl: z.string().nullable(),
    alreadyExported: z.boolean(),
});
export const XeroDisconnectResponseSchema = z.object({
    success: z.boolean(),
});
// =============================================================================
// Xero Connection - E2E Bypass
// =============================================================================
export const E2ESeedStaleXeroConnectionInputSchema = z.object({
    accountId: z.string().uuid(),
});
export const E2ESeedStaleXeroConnectionResponseSchema = z.object({
    connectionId: z.string().uuid(),
});
